 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		5: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		5: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"route-game-challenge-root-1~route-simple-game-root-1","7":"route-activtiy-game-root-1","8":"route-client-guard-root-1","9":"route-direct-root-1","10":"route-game-challenge-root-1","11":"route-intro-root-1","12":"route-intro-root-2","13":"route-main-error-root-1","14":"route-multi-step-root-1","15":"route-plane-banner-root-1","16":"route-referral-root1","17":"route-reward-card-root-1","18":"route-reward-root-1","19":"route-simple-game-root-1","20":"route-streak-root-1","21":"route-wallet-root-1"}[chunkId]||chunkId) + ".chunk." + {"0":"f81af","1":"345e5","2":"a49e6","3":"0824d","4":"c5a46","7":"a11eb","8":"d3e3c","9":"092bf","10":"c630b","11":"35f99","12":"f335f","13":"9c944","14":"e0db8","15":"b2543","16":"0db82","17":"42d2a","18":"c21b6","19":"990bd","20":"22df2","21":"5c764","22":"87aa1","23":"8c6b3","24":"c414e","25":"ad9ba","26":"54118","27":"45363","28":"2b1d9","29":"1d9a0","30":"1507c","31":"11968","32":"4f1b6","33":"93438","34":"caa7b","35":"982ec","36":"255e8","37":"c275b","38":"e1ef1","39":"4fd9b","40":"b053f","41":"7857e","42":"74cf6","43":"e0ba8","44":"8b8fc","45":"d6a56","46":"50b13","47":"86321","48":"418e6","49":"70265","50":"75e07","51":"09529","52":"95f1c","53":"5b405","54":"da9c9","55":"581e8","56":"3b02f","57":"72ebb","58":"6868f","59":"7f375","60":"be522","61":"cb6f7","62":"b3ec8","63":"b13fa","64":"73b0c","65":"f5529","66":"49e1c","67":"3928e","68":"def70","69":"e83cb","70":"824ab","71":"4bf22","72":"a8e98","73":"65977","74":"9d473","75":"e6c59","76":"2bbaf","77":"88ab7","78":"90035","79":"8a160","80":"08bbf","81":"f25a5","82":"940c8","83":"655f0","84":"6b6d6","85":"5fba0","86":"75ac2","87":"373dd","88":"7f67a","89":"98e70","90":"db4ec","91":"1e4b5","92":"78721","93":"a7cb4","94":"329a5","95":"27a31","96":"1b3a2","97":"09b89","98":"07fc8","99":"86c07","100":"6a727","101":"6492a","102":"2faca","103":"789ea","104":"69682","105":"8627f","106":"48796","107":"9c8cf","108":"f58ab","109":"aa8fe","110":"f1bcd","111":"6db94"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"1":1,"7":1,"8":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"29":1,"31":1,"32":1,"33":1,"34":1,"35":1,"36":1,"37":1,"38":1,"39":1,"40":1,"41":1,"42":1,"45":1,"46":1,"47":1,"48":1,"49":1,"51":1,"52":1,"53":1,"54":1,"55":1,"56":1,"57":1,"58":1,"59":1,"64":1,"65":1,"66":1,"68":1,"69":1,"70":1,"71":1,"72":1,"73":1,"74":1,"75":1,"76":1,"77":1,"78":1,"79":1,"80":1,"81":1,"82":1,"83":1,"84":1,"85":1,"86":1,"87":1,"88":1,"89":1,"90":1,"91":1,"92":1,"93":1,"94":1,"95":1,"96":1,"97":1,"98":1,"99":1,"100":1,"101":1,"102":1,"103":1,"104":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"1":"route-game-challenge-root-1~route-simple-game-root-1","7":"route-activtiy-game-root-1","8":"route-client-guard-root-1","9":"route-direct-root-1","10":"route-game-challenge-root-1","11":"route-intro-root-1","12":"route-intro-root-2","13":"route-main-error-root-1","14":"route-multi-step-root-1","15":"route-plane-banner-root-1","16":"route-referral-root1","17":"route-reward-card-root-1","18":"route-reward-root-1","19":"route-simple-game-root-1","20":"route-streak-root-1","21":"route-wallet-root-1"}[chunkId]||chunkId) + ".chunk." + {"0":"0ac19","1":"eac1f","2":"31d6c","3":"31d6c","4":"31d6c","7":"f96d5","8":"3ba37","9":"8bbda","10":"8d73c","11":"e5716","12":"9ba5d","13":"3ba37","14":"c3e61","15":"eba1e","16":"6ee16","17":"8ae8b","18":"b97d0","19":"6572f","20":"4c9d3","21":"4be6e","22":"7d5af","23":"95e5c","24":"31d6c","25":"31d6c","26":"31d6c","27":"31d6c","28":"31d6c","29":"46352","30":"31d6c","31":"c0105","32":"d23c9","33":"4e576","34":"647d4","35":"e7378","36":"9bb40","37":"e5caf","38":"5a68e","39":"fd64a","40":"59183","41":"22ba7","42":"f2bb8","43":"31d6c","44":"31d6c","45":"33c72","46":"f2bb8","47":"beb99","48":"49c30","49":"10def","50":"31d6c","51":"c2ca9","52":"be82f","53":"a99a9","54":"c526b","55":"aada8","56":"1892b","57":"3deea","58":"ce97b","59":"b48c6","60":"31d6c","61":"31d6c","62":"31d6c","63":"31d6c","64":"56bf3","65":"9a109","66":"880ad","67":"31d6c","68":"5328c","69":"1ec48","70":"8ad8d","71":"a86fe","72":"c42c2","73":"3536d","74":"05660","75":"8fdc4","76":"f5f9d","77":"b410f","78":"f43f6","79":"abbfe","80":"4e837","81":"a6b08","82":"c40dc","83":"42ad7","84":"ab04f","85":"c953d","86":"a964a","87":"6d971","88":"3ba37","89":"11c4d","90":"a638e","91":"f440c","92":"cbf29","93":"05c63","94":"59e56","95":"c791f","96":"e3fbf","97":"1feb0","98":"55dcb","99":"09ce7","100":"49aab","101":"0414f","102":"e0d44","103":"8b7dd","104":"0c334","105":"31d6c","106":"31d6c","107":"31d6c","108":"31d6c","109":"31d6c","110":"31d6c","111":"31d6c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = "mdyV");
